import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BcAccountClientService } from '../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from 'ng2-bootstrap-modal';
import { BcEreasonSelectorComponent } from './bc-e-committee/bc-e-committee-reason/bc-e-committee-reason.component';
import { BcEreasonBillingComponent } from './bc-e-committee/bc-e-billing-reason/bc-e-billing-reason.component';

@Component({
	selector: 'app-bc-extension-proposal',
	templateUrl: './bc-extension-proposal.component.html',
	styleUrls: ['./bc-extension-proposal.component.scss']
})

export class BcExtensionProposalComponent implements OnInit {

	@Input('PropostaProrrogacaoID') PropostaProrrogacaoID = '';
	@Input('PropostaProrrogacaoStatus') PropostaProrrogacaoStatus = '';
	@Input('accountClientID') accountClientID = '';
	@Input('profileUser') profileUser = '';
	@Input('CodigoSap') CodigoSap = '';

	// LocalStorage
	private permissoes;
	private userID;

	//Data
	public extensionProposal: any[] = [];
	private requiredMessages = [];

	// Permission
	private canSave;
	private canSendToCommittee;
	private canSendToBilling;
	private canCancel;
	private canApproveExtension;

	// Controladores de exibição
	private showRestricao;
	private showGarantia;
	private showParcelamento;

	// Controladores de edição
	private canEdit;
	private canEditFields;
	private canEditComercial;
	private canEditCobranca;

    public proposalSubscription; // Control changes in Proposal
	public showLoader = false;
	public parcela: boolean = false;
	public garantia: boolean = false;
	public parcelas: any[] = [];
	public Valor;
	public reasonOfExtensions: any[] = [];
	public moneySources: any[] = [];
	public guaranteeTypes: any[] = [];
	public valorProrrogado: number = 0;
	private isLoaded = false;
	public extensionDetails: any[] = [];
	public selectedCtcId;
	public commentary;

	constructor(private bcAccountClientService: BcAccountClientService, private router: Router, private flashMessagesService: FlashMessagesService, private dialogService: DialogService) { }

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.userID = localStorage.getItem('yara.userID');

        this.proposalSubscription = this.bcAccountClientService.proposalChanged.subscribe(proposalChanged => {
			this.getExtensionProposal();
        });

		if (window.location.href.indexOf('proposta-prorrogacao') != -1) {
			this.loadProposal();
		}
	}



	permissionSendToComittee() {

		//reset
		this.requiredMessages = [];

		if (!this.extensionProposal['MotivoProrrogacaoID']){
			this.requiredMessages.push("É necessário informar o Motivo da Prorrogação.");
		}
		if (!this.extensionProposal['OrigemRecursoID']){
			this.requiredMessages.push("É necessário informar a Origem dos Recursos.");
		}
		if (!this.extensionProposal['TaxaSugerida']){
			this.requiredMessages.push("É necessário informar a Taxa Sugerida.");
		} 
		if (!this.extensionProposal['ParecerCobranca'] || this.extensionProposal['ParecerCobranca'] == ''){
			this.requiredMessages.push("É necessário informar o Parecer Cobrança.");
		}

		if (this.requiredMessages.length > 0){
			return false;
		} else{
			return true;
		}
	}

	permissionSendToBilling() {

		//reset
		this.requiredMessages = [];
		
		if (!this.extensionProposal['MotivoProrrogacaoID']){
			this.requiredMessages.push("É necessário informar o Motivo da Prorrogação.");
		}
		if (!this.extensionProposal['OrigemRecursoID']){
			this.requiredMessages.push("É necessário informar a Origem dos Recursos.");
		}
		if (!this.extensionProposal['TaxaSugerida']){
			this.requiredMessages.push("É necessário informar a Taxa Sugerida.");
		}
		if (!this.extensionProposal['ParecerComercial'] || this.extensionProposal['ParecerComercial'] == ''){
			this.requiredMessages.push("É necessário informar o Parecer Comercial.");
		}

		if (this.requiredMessages.length > 0){
			return false;
		} else{
			return true;
		}

	}

	sendExtensionToCommitteeModal() {
		if (this.permissionSendToComittee()) {
			if (this.permissionSendToComittee) {
				this.dialogService.addDialog(BcEreasonSelectorComponent, { clientID: this.accountClientID }, { backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe((result) => { // We get dialog result
					if (result) {
						this.saveExtensionProposal(this.extensionProposal, false, null, true);
						this.selectedCtcId = result.selectedCTC;
						this.commentary = result.commentary;
					}
					else {
						this.showLoader = false;
						this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
					}
				}, error => {
					this.showLoader = false;
					console.log(error);
				});
					
			}
		}
	}

	sendExtensionToCommittee(selectedCtcId, commentary) {
		var obj = {
			ContaClienteID: this.accountClientID,
			Motivo: commentary,
			CodigoSap: selectedCtcId, // this.extensionProposal['CodigoSap'],
			ID: this.extensionProposal['ID']
		}

		this.bcAccountClientService.sendExtensionToCommittee(obj).subscribe(result => {
			this.showLoader = false;
			if (result.Success) {
				this.flashMessagesService.show("Proposta de Prorrogação enviada ao Comitê.", { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/').then(
					() => {
						this.router.navigate(['/conta-cliente/detalhe', this.accountClientID, 'proposta-prorrogacao']);
					});
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			this.showLoader = false;
			console.log(error);
		});
	}

	getExtensionDetails() {
		this.bcAccountClientService.getExtensionDetails(this.extensionProposal['ID']).subscribe(result => {
			if (result.Success) {
				this.extensionDetails = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	sendToBillingCommentary() {
		if (this.permissionSendToBilling()){
			this.dialogService.addDialog(BcEreasonBillingComponent, { clientID: this.accountClientID }, { backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe((result) => { // We get dialog result
				if (result) {
					const commentary = result.commentary;
					const ctc = result.ctc;
					this.sendToBilling(commentary, ctc);
				}
				else { // Do nothing here

				}
			});
		}
	}

	sendToBilling(commentary, ctc) {
		var obj = {
			id: this.PropostaProrrogacaoID,
			ContaClienteID: this.accountClientID,
			CodigoSap: ctc,
			Motivo: commentary
		}

		this.extensionProposal['CodigoSap'] = ctc; // Salva o CTC na proposta

		this.saveExtensionProposal(this.extensionProposal, true, obj, false);
	}

	loadProposal() {
		if (!this.isLoaded) {
			this.getExtensionProposal();
			this.searchReasonOfExtension();
			this.searchMoneySource();
			this.searchGuaranteeType();
			this.isLoaded = true;
		}
	}

	resetPermission() {
		this.canSave = false;
		this.canSendToCommittee = false;
		this.canSendToBilling = false;
		this.canCancel = false;
		this.canApproveExtension = false;

		this.showRestricao = false;
		this.showGarantia = false;
		this.showParcelamento = false;

		this.canEdit = false;
		this.canEditFields = false;
		this.canEditComercial = false;
		this.canEditCobranca = false;
	}

	/*
		ID	Status
		AA	Aprovado Automático
		AC	Aguardando ação do analista de cobrança
		AP	Aprovado
		CA	Cancelada
		CC	Enviado Cobrança
		EA	Em Aprovação
		EC	Em Criação
		EN	Encerrada
		ET	Aguardando Parecer do CTC
		RE	Rejeitada
	*/
	verifyPermissions() {
		this.resetPermission();
		if (this.extensionProposal['PropostaCobrancaStatusID'] == "EC") {
			console.log("EM CRIACAO");
			if (this.profileUser == "Analista de Cobrança") {
				this.canSave = this.permissoes['Prorrogacao_Editar'];
				this.canCancel = this.permissoes['Prorrogacao_Cancelar'];
				this.canSendToCommittee = this.permissoes['Prorrogacao_CobrancaComite'];

				this.showRestricao = true;
				this.showGarantia = true;
				this.showParcelamento = true;

				this.canEdit = true;
				this.canEditFields = true;
				this.canEditCobranca = true;
			}
			else if (this.profileUser == "Consultor Técnico Comercial") {
				if (this.userID == this.extensionProposal['ResponsavelID']) {
					this.canSave = this.permissoes['Prorrogacao_Editar'];
					this.canCancel = this.permissoes['Prorrogacao_Cancelar'];
					this.canSendToBilling = this.permissoes['Prorrogacao_Cobranca'];

					this.canEdit = true;
					this.canEditFields = true;
					this.canEditComercial = true;
				}
			}
		}
		else if (this.extensionProposal['PropostaCobrancaStatusID'] == "CC") {
			console.log("COBRANCA");
			if (this.profileUser == "Analista de Cobrança") {
				this.canSave = this.permissoes['Prorrogacao_Editar'];
				this.canCancel = this.permissoes['Prorrogacao_Cancelar'];
				this.canSendToCommittee = this.permissoes['Prorrogacao_CobrancaComite'];

				this.showRestricao = true;
				this.showGarantia = true;
				this.showParcelamento = true;

				this.canEditFields = true;
				this.canEditCobranca = true;
			}
		}
		else if (this.extensionProposal['PropostaCobrancaStatusID'] == "EA") {
			console.log("EM APROVACAO");
			if (this.profileUser == "Analista de Cobrança") {
				this.canCancel = this.permissoes['Prorrogacao_Cancelar'];

				this.showRestricao = true;
				this.showGarantia = true;
				this.showParcelamento = true;
			}
		}
		else if (this.extensionProposal['PropostaCobrancaStatusID'] == "AC") {
			console.log("AGUARDANDO AÇÃO DO ANALISTA");
			if (this.profileUser == "Analista de Cobrança") {
				this.canApproveExtension = this.permissoes['Prorrogacao_Efetivar'];
				this.canCancel = this.permissoes['Prorrogacao_Cancelar'];

				this.showRestricao = true;
				this.showGarantia = true;
				this.showParcelamento = true;
			}
		}
	}

	getExtensionProposal() {
		this.bcAccountClientService.getExtensionProposal(this.PropostaProrrogacaoID).subscribe(result => {
			if (result.Success) {
				this.extensionProposal = result.Result;
				this.verifyPermissions();

				console.log("Prorrogação", this.extensionProposal);

				let sum = 0;

				result.Result.Titulos.forEach(item => {
					sum += item.ValorInterno;
				});

				this.valorProrrogado = sum;

				this.garantia = result.Result.AgregaGarantia;

				if (result.Result.Parcelamentos) {
					for (var i = 0; i < result.Result.Parcelamentos.length; i++) {
						var parc = {
							Parcela: result.Result.Parcelamentos[i].Parcela,
							Valor: result.Result.Parcelamentos[i].Valor,
							Ativo: result.Result.Parcelamentos[i].Ativo
						}
						this.parcelas.push(parc);
					}
				}

				if (this.parcelas.length > 0) {
					this.parcela = true;
				}

				this.getExtensionDetails();

				if (window.location.href.indexOf('proposta-prorrogacao') != -1) {
					$(".extension-click").removeClass("collapsed").attr("aria-expanded", "true");
					$("#collapseBCCliExtension").addClass("show");
					$('html, body').animate({ scrollTop: $("#headingBCCliExtension").offset().top - 20 }, 500);
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	addParcela(valor) {
		var obj = {
			Parcela: this.parcelas.length + 1,
			Valor: valor,
			Ativo: true
		}

		this.parcelas.push(obj);
		this.Valor = 0;
	}

	removeParcela(index) {
		delete this.parcelas[index];
		this.parcelas = this.parcelas.filter(item => item);
	}

	saveExtensionProposal(obj, sendToBilling, billing, sendCommittee) {
		this.showLoader = true;

		var proposal = {
			Acompanhar: obj.Acompanhar,
			MotivoProrrogacaoID: obj.MotivoProrrogacaoID,
			OrigemRecursoID: obj.OrigemRecursoID,
			TaxaSugerida: obj.TaxaSugerida,
			Favoravel: obj.Favoravel,
			RestricaoSerasa: obj.RestricaoSerasa,
			AgregaGarantia: obj.AgregaGarantia,
			ParecerComercial: obj.ParecerComercial,
			ParecerCobranca: obj.ParecerCobranca,
			TipoGarantiaID: obj.TipoGarantiaID,
			Parcelamentos: [],
			id: ''
		}

		proposal.Parcelamentos = this.parcelas;
		proposal.id = this.PropostaProrrogacaoID;

		this.bcAccountClientService.saveExtensionProposal(proposal).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta de Prorrogação salva com sucesso!", { cssClass: 'alert-success', timeout: 6000 });

				if (sendCommittee) {
					this.sendExtensionToCommittee(this.selectedCtcId, this.commentary);
				}

				if (sendToBilling) {
					this.bcAccountClientService.sendToBilling(billing).subscribe(result => {
						this.showLoader = false;
						if (result.Success) {
							this.flashMessagesService.show("Proposta de Prorrogação enviada para Cobrança com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
							this.isLoaded = false;
							this.loadProposal();
						} else {
							this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
						}
					}, error => {
						this.showLoader = false;
						console.log(error);
					});
				}
				
				this.showLoader = false;
			} else {
				this.showLoader = false;
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			this.showLoader = false;
			console.log(error);
		});
	}

	percentualCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength);
		} else {
			if (e.target.value > 100) {
				e.target.value = 100;
			} else if (e.target.value < 0) {
				e.target.value = 0;
			}
		}
	}

	cancelExtensionProposal() {
		var proposalID = this.PropostaProrrogacaoID;

		this.bcAccountClientService.cancelExtensionProposal(proposalID).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta de Prorrogação cancelada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/').then(
					() => {
						this.router.navigate(['/conta-cliente/detalhe', this.accountClientID, 'cobranca']);
					});
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	approvalExtensionProposal() {
		var obj = {
			ID: this.PropostaProrrogacaoID,
			ContaClienteID: this.accountClientID
		}

		this.bcAccountClientService.approvalExtensionProposal(obj).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Proposta de Prorrogação efetivada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/').then(
					() => {
						this.router.navigate(['/conta-cliente/detalhe', this.accountClientID, 'cobranca']);
					});
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	searchReasonOfExtension() {
		this.bcAccountClientService.searchReasonOfExtension().subscribe(result => {
			if (result.Success) {
				this.reasonOfExtensions = result.Result;
				console.log("reason of extension", this.reasonOfExtensions);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	searchMoneySource() {
		this.bcAccountClientService.searchMoneySource().subscribe(result => {
			if (result.Success) {
				this.moneySources = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	searchGuaranteeType() {
		this.bcAccountClientService.searchGuaranteeType().subscribe(result => {
			if (result.Success) {
				this.guaranteeTypes = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}
}


// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-extension-proposal.component.ts